import Companies from "./Components/Companies";
import Guide from "./Components/Guide";
import Hero from "./Components/Hero";
import Properties from "./Components/Properties";
import Details from "./Components/Details";
import GetStarted from "./Components/GetStarted";
import Footer from "./Components/Footer";

function App() {
  return (
    <>
      <Hero />
      <Properties/>
      <Guide />
      <Details />
      <Companies />
      <GetStarted />
      <Footer />
    </>
  );
}

export default App;
